import React, { useRef } from 'react'
import styles from './Problem.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

type Props = {
  contents: {
    title: string
    subTitle: string
    list: {
      icon: string
      text: string | JSX.Element
    }[]
  }
}

export const Problem: React.FC<Props> = ({ contents }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)
  return (
    <section
      className={`${styles.problem} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.problem__inner}>
        <div className={styles.problem__header}>
          <p className={styles.problem__title}>{contents.title}</p>
          <p className={styles.problem__subtitle}>{contents.subTitle}</p>
        </div>
        <div className={styles.problem__list}>
          {contents.list.map((item, index) => (
            <div key={index} className={styles.problem__item}>
              <div className={styles.problem__icon}>
                <figure>
                  <img src={item.icon} alt="" className={styles.problem__image} />
                </figure>
              </div>
              <p className={styles.problem__text}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
